<template>
    <div>
        <div>
            <range-slider
                :min="minimumPrice"
                :max="maximumPrice"
                :step="step"
                :start="+internalStartSliderValue"
                :end="+internalEndSliderValue"
                :ballWidth="28"
                :barHeight="10"
                trackColor="#d3d3d3"
                rangeColor="#808080"
                @slideEnd="slideEnd"
            >
            </range-slider>
        </div>
        <div class="d-flex justify-content-between mx-3">
            <div class="form-group">
                <div class="input-group">
                    <label id="MinimumPaymentValue">
                        <Pula :amount="internalStartSliderValue" />
                    </label>
                </div>
            </div>
            <div class="flex-fill mx-3">
                <hr class="mt-2" />
            </div>
            <div class="form-group">
                <div class="input-group">
                    <label id="MaximumPaymentValue">
                        <Pula :amount="internalEndSliderValue" />
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RangeSlider from "./RangeSlider";
import Pula from "./Pula";

export default {
    name: "PriceFilter",
    components: {
        Pula,
        RangeSlider
    },
    props: {
        editAmount: { type: Boolean, default: false },
        minimumPrice: { required: true, type: Number },
        maximumPrice: { required: true, type: Number },
        startSliderValue: { required: true, type: Number },
        endSliderValue: { required: true, type: Number },
        step: { type: Number, default: 100 }
    },
    data() {
        return {
            internalStartSliderValue:
                this.startSliderValue ?? this.minimumPrice,
            internalEndSliderValue: this.endSliderValue ?? this.maximumPrice
        };
    },
    watch: {
        startSliderValue: "updateSliderValues",
        endSliderValue: "updateSliderValues"
    },
    methods: {
        updateSliderValues() {
            this.internalStartSliderValue = this.startSliderValue;
            this.internalEndSliderValue = this.endSliderValue;
        },
        slideEnd($event) {
            this.internalStartSliderValue = $event.start;
            this.internalEndSliderValue = $event.end;
            this.$emit("price-range-changed", $event);
        }
    }
};
</script>
>
